export default "__VITE_ASSET__BAwPCkHE__"